/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLabelExclamationMark: {
  name: 'label-exclamation-mark';
  data: string;
} = {
  name: 'label-exclamation-mark',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.646.646a.5.5 0 0 1 .416-.142l8 1a.5.5 0 0 1 .292.142l6 6.002a.5.5 0 0 1 0 .707l-7 7a.5.5 0 0 1-.708 0l-6-6.001a.5.5 0 0 1-.142-.292l-1-8A.5.5 0 0 1 .646.646Zm.93.93.899 7.192L8 14.294 14.293 8 8.768 2.475l-7.192-.9ZM8 4a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0v-5A.5.5 0 0 1 8 4Zm0 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
